import TruckSizeList from './pages/ListPage.vue'
import TruckSizeDetail from './pages/FormPage.vue'
import TruckSizeIndex from './pages/IndexPage.vue'

export default [
  {
    path: '/truck_size',
    component: TruckSizeIndex,
    redirect: '/truck_size/list',
    name: 'truck_size',
    children: [
      {
        path: 'list',
        component: TruckSizeList,
        name: 'truck_size.list'
      },
      {
        path: 'create',
        component: TruckSizeDetail,
        name: 'truck_size.create',
        props: {create: true},
      },
      {
        path: 'edit/:id',
        component: TruckSizeDetail,
        name: 'truck_size.edit',
        props: {create: false},
      },
    ],
  },
]
